<template>
    <div v-if="initialized">
        <template v-if="!currentUser">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <form class="form-inline">
                        <input type="text"
                            v-model="userSearch"
                            placeholder="Keyword Search"
                            class="mr-sm-2 form-control form-control-sm">
                    </form>
                </div>
                <div class="col-md-6 mb-3">
                    <form>
                        <div class="input-group">
                            <span class="input-group-prepend">
                                <label for="webhook-url" class="input-group-text">Webhook URL:</label>
                            </span>
                            <input id="webhook-url"
                                type="text"
                                class="form-control"
                                value="https://sendgrid.theconferencecompany.com/webhook/sendgrid"
                                readonly>
                            <span class="input-group-append">
                                <button class="btn btn-default btn-copy"
                                        type="button"
                                        data-clipboard-target="#webhook-url"
                                        >Copy</button>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div v-for="user in _.values(filteredUsers)"
                    :key="user.id"
                    class="col-sm-6">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">{{ _.get(user, 'attributes.name', '') }}</h5>
                            <button v-on:click="() => currentUser = user" class="btn btn-primary">View Reports</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="!currentCampaign">
            <div class="card">
                <div class="card-header">
                    {{ _.get(currentUser, 'attributes.name') }} All Campaigns
                    <div class="dropdown float-right">
                        <button v-on:click="() => currentUser = null"
                            class="btn btn-rounded btn-secondary btn-sm"
                            style="min-width: 10rem"
                            type="button"
                            aria-haspopup="true"
                            aria-expanded="false">
                            Back to Users
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="col-sm-6">
                            <label for="fromDate" class="col-form-label">From date:</label>
                            <vue-flatpickr-component
                                v-model="dateRange[0]"
                                class="form-control"
                                ></vue-flatpickr-component>
                        </div>
                        <div class="col-sm-6">
                            <label for="toDate" class="col-form-label">To date:</label>
                            <vue-flatpickr-component
                                v-model="dateRange[1]"
                                class="form-control"
                                ></vue-flatpickr-component>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button v-on:click="() => getUserReports(currentUser)"
                        class="btn btn-primary">Apply</button>
                </div>
            </div>
            <div v-if="loading" style="">
                <vue-spinner style="margin: 10% 50%;"></vue-spinner>
            </div>
            <template v-else>
                <section class="box-typical box-typical-dashboard panel panel-default scrollable">
                    <campaign-report-component
                        :reports="reports"
                        ></campaign-report-component>
                </section>
                <div class="row">
                    <div class="col mb-3">
                        <form class="form-inline">
                            <input type="text"
                                   v-model="campaignSearch"
                                   placeholder="Keyword Search"
                                   class="mr-sm-2 form-control form-control-sm">
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div v-for="campaign in _.values(filteredCampaigns)"
                         :key="campaign.id"
                         class="col-sm-6">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">{{ _.get(campaign, 'attributes.name', '') }}</h5>
                                <p class="card-text">
                                    <template v-if="_.get(campaign, 'attributes.subject')">
                                        Subject: {{ _.get(campaign, 'attributes.subject') }}</br>
                                    </template>
                                    <template v-if="_.get(campaign, 'attributes.tag_code')">
                                        Tag Code: {{ _.get(campaign, 'attributes.tag_code') }}</br>
                                    </template>
                                    Delivered to: {{ _.get(campaign, 'attributes.message_number', 0) }}
                                </p>
                                <button v-on:click="() => currentCampaign = campaign" class="btn btn-primary">View Campaign Report</button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="card">
                <div class="card-header">
                    {{ _.get(currentCampaign, 'attributes.name', '') }}
                    <div class="dropdown float-right">
                        <button v-on:click="() => currentCampaign = null"
                            class="btn btn-rounded btn-secondary btn-sm"
                            style="min-width: 10rem"
                            type="button"
                            aria-haspopup="true"
                            aria-expanded="false">
                            Back to Campaigns
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-row">
                        <div class="col-sm-6">
                            <label for="fromDate" class="col-form-label">From date:</label>
                            <vue-flatpickr-component
                                v-model="dateRange[0]"
                                class="form-control"
                                ></vue-flatpickr-component>
                        </div>
                        <div class="col-sm-6">
                            <label for="toDate" class="col-form-label">To date:</label>
                            <vue-flatpickr-component
                                v-model="dateRange[1]"
                                class="form-control"
                                ></vue-flatpickr-component>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button v-on:click="() => getCampaignReports(currentCampaign)"
                        class="btn btn-primary">Apply</button>
                </div>
            </div>
            <div v-if="loading" style="">
                <vue-spinner style="margin: 10% 50%;"></vue-spinner>
            </div>
            <template v-else>
                <section class="box-typical box-typical-dashboard panel panel-default scrollable">
                    <campaign-report-component
                        :reports="reports"
                        ></campaign-report-component>
                    <message-table-component
                        :campaign="currentCampaign"
                        :dateRange="dateRange"
                        :api="api"
                        ></message-table-component>
                </section>
            </template>
        </template>
    </div>
</template>
<script>
import M from 'moment';
import Clipboard from 'clipboard';
import Vuex from 'vuex';
import VueSpinner from 'vue-spinner/src/MoonLoader.vue';
import VueFlatpickrComponent from 'vue-flatpickr-component';
import CampaignReportComponent from './report/CampaignReportComponent.vue';
import CampaignTableComponent from './report/CampaignTableComponent.vue';
import MessageTableComponent from './report/MessageTableComponent.vue';

export default {
    data() {
        const dateRange = [
            M().subtract(1, 'month').format('YYYY-MM-DD'),
            M().format('YYYY-MM-DD'),
        ];

        return {
            api: null,
            initialized: false,
            loading: false,
            currentUser: null,
            currentCampaign: null,
            reports: [],
            messages: [],
            campaigns: [],
            campaignSearch: '',
            users: [],
            userSearch: '',
            dateRange,
        }
    },

    props: ['label', 'endpoint'],

    components: {
        VueSpinner,
        VueFlatpickrComponent,
        CampaignReportComponent,
        CampaignTableComponent,
        MessageTableComponent,
    },

    created() {
        const params = new URLSearchParams(window.location.search);
        this.initialized = false;
        this.api = this.helpers('api');

        window.addEventListener('popstate', this.updateCurrentState);

        if (_.chain(this.cmsUser)
            .get('role.permissions')
            .split(',')
            .intersection(['report.admin', '*.*'])
            .isEmpty()
            .value()
        ) {

            this.currentUser = {
                id: this.cmsUser.id,
                attributes: _.clone(this.cmsUser),
            }
            this.users = [this.currentUser];

            this.initialized = true;
            return;
        }

        return this.api.getData('/users', {
            filter: `active:1;id:$has(campaigns,1)`,
            sort: 'name:asc',
            per_page: 1000,
        }).then((users) => {
            this.users = users.data;
            if (params.get('user_id')) {
                this.currentUser = _.find(this.users, (u) => u.id == params.get('user_id'));
            }
        }).finally(() => this.initialized = true)
    },

    mounted() {
        this.$nextTick(() => {
            let clipboard = new Clipboard('.btn-copy');
            clipboard.on('success', (e) => {
                alert('Webhook URL copied to clipboard');
            })
        })
    },

    destroyed() {
        this.initialized = false;
        window.removeEventListener('popstate', this.updateCurrentState);
    },

    watch: {
        dateRange(newVal) {
            this.loading = true;
            return this.api.getData(`/user/${this.currentUser.id}/campaigns`, {
                filter: `active:1;id:$has(messages,1);id(r):$reportrange(${this.getDateRangeFilter(newVal)})`,
                sort: 'title:asc',
                per_page: 1000,
            }).then(campaigns => {
                this.campaigns = campaigns.data;
                return this.getUserReports(this.currentUser, newVal);
            }).finally(() => {
                this.loading = false;
            })
        },

        currentUser(newVal) {
            const params = new URLSearchParams(window.location.search);
            if (!newVal) {
                params.set('user_id', '');
                window.history.pushState(null, null, `?${params.toString()}`);
                return;
            }

            this.loading = true;
            return this.api.getData(`/user/${newVal.id}/campaigns`, {
                filter: `active:1;id:$has(messages,1);id(r):$reportrange(${this.getDateRangeFilter(this.dateRange)})`,
                sort: 'title:asc',
                per_page: 1000,
            }).then(campaigns => {
                this.campaigns = campaigns.data;
                if (params.get('campaign_id')) {
                    this.currentCampaign = _.find(this.campaigns, (c) => c.id == params.get('campaign_id'));
                    return;
                }

                return this.getUserReports(newVal);

            }).finally(() => {
                params.set('user_id', newVal.id);
                window.history.pushState(null, null, `?${params.toString()}`);
                this.loading = false;
            })
        },

        currentCampaign(newVal) {
            const params = new URLSearchParams(window.location.search);

            if (!newVal) {
                this.loading = true;
                return this.getUserReports(this.currentUser)
                    .finally(() => {
                        this.loading = false;
                        params.set('campaign_id', '');
                        window.history.pushState(null, null, `?${params.toString()}`);
                    })
            }

            this.loading = true;
            this.getCampaignReports(newVal)
                .finally(() => {
                    this.loading = false;
                    params.set('campaign_id', newVal.id);
                    window.history.pushState(null, null, `?${params.toString()}`);
                });
        },
    },

    computed: {
        ...Vuex.mapGetters({
            cmsUser: 'user',
        }),

        filteredUsers() {
            return _.chain(this.users)
                .filter(u => {
                    const searchTerm = _.chain(u)
                        .get('attributes')
                        .pick(['name', 'email'])
                        .values()
                        .join(' ')
                        .value();

                    return searchTerm.toLowerCase()
                        .indexOf(this.userSearch.toLowerCase()) >= 0;
                })
                .value()
        },

        filteredCampaigns() {
            return _.chain(this.campaigns)
                .filter(c => {
                    const searchTerm = _.chain(c)
                        .get('attributes')
                        .pick(['title', 'event_name', 'tag_code'])
                        .values()
                        .join(' ')
                        .value();

                    return searchTerm.toLowerCase()
                        .indexOf(this.campaignSearch.toLowerCase()) >= 0;
                })
                .value()
        },
    },

    methods: {
        ...Vuex.mapActions(['changeUrl']),

        getCampaignReports(campaign) {
            return this.api.getData(`/campaign/${_.get(campaign, 'id')}/reports`, {
                filter: `reported_at:$range(${this.getDateRangeFilter(this.dateRange)})`,
                per_page: 9999,
            })
            .then((reports) => {
                this.reports = reports.data;
            })
        },

        getUserReports(user, dateRange = null) {
            return this.api.getData(`/user/${user.id}/reports`, {
                filter: `reported_at:$range(${this.getDateRangeFilter(dateRange || this.dateRange)})`,
                per_page: 1000,
            }).then((reports) => {
                this.reports = reports.data;
            })
        },

        updateCurrentState(e) {
            const params = new URLSearchParams(window.location.search);

            this.currentUser = _.find(
                this.users,
                (u) => u.id == params.get('user_id')
            ) || null;
            this.currentCampaign = _.find(
                this.campaigns,
                (c) => c.id == params.get('campaign_id')
            ) || null;

            return this.getReports();
        },

        getReports() {
            if (this.currentCampaign) {
                return this.getCampaignReports(this.currentCampaign);
            }

            if (this.currentUser) {
                return this.getUserReports(this.currentUser);
            }
        },

        getDateRangeFilter(dateRange) {
            let [fromDate, toDate] = dateRange;
            return M(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') + ',' + M(toDate, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/DashboardReportComponent.vue